import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { StyledBaseButton, StyledActionButtonLabel, StyledActionButtonLabelHeading, StyledActionButtonLabelDescription, StyledActionButtonIconRightContainer } from './ActionButton.style.js';
import ArrowRightIcon from '../Icon/icons/ArrowRight.js';

const ActionButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    as,
    children,
    description,
    iconRight,
    variant,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledBaseButton, _extends({
    $variant: variant
  }, rest, {
    ref: ref,
    forwardedAs: as
  }), /*#__PURE__*/React__default.createElement(StyledActionButtonLabel, {
    $variant: variant
  }, /*#__PURE__*/React__default.createElement(StyledActionButtonLabelHeading, {
    $variant: variant
  }, children), description && /*#__PURE__*/React__default.createElement(StyledActionButtonLabelDescription, {
    $variant: variant
  }, description)), /*#__PURE__*/React__default.createElement(StyledActionButtonIconRightContainer, null, iconRight ? /*#__PURE__*/cloneElement(iconRight, {
    block: true,
    size: variant === 'small' ? 'lg' : 'xl',
    ...iconRight.props
  }) : /*#__PURE__*/React__default.createElement(ArrowRightIcon, {
    block: true,
    size: variant === 'small' ? 'lg' : 'xl'
  })));
});

// @ts-expect-error
ActionButton.displayName = 'ActionButton';
// @ts-expect-error
ActionButton.propTypes = {
  /**
   * Element or component used for the root node.
   */
  as: PropTypes.elementType,
  /**
   * The component or text used as the header text for the button.
   */
  children: PropTypes.node,
  description: PropTypes.node,
  iconRight: PropTypes.element,
  onClick: PropTypes.func,
  /**
   * Defines the variant used. Small variant is used in <ActionButtonGroup>
   */
  variant: PropTypes.oneOf(['small'])
};

export { ActionButton };
